var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegister = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0C2.5575 0 2.3925 0.0275 2.2275 0.0825C1.155 0.3025 0.3025 1.155 0.0825 2.2275C0 2.3925 0 2.5575 0 2.75V17.875C0 20.1575 1.8425 22 4.125 22H19.25V19.25H4.125C3.355 19.25 2.75 18.645 2.75 17.875C2.75 17.105 3.355 16.5 4.125 16.5H19.25V1.375C19.25 0.605 18.645 0 17.875 0H16.5V8.25L13.75 5.5L11 8.25V0H2.75Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegister);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Register.25e6184c0ae59a1c51c0bf497839143c.svg";